import { create } from 'zustand';
import { CancelTokenSource } from 'axios';
import ResponseError from '../../types/response/ResponseError';
import { Log } from '../../types/log/Log';
import { PagingResponseData } from '../../types/response/PagingResponseData';

export interface LogsStore {
    isSearching: boolean;
    searchResult: PagingResponseData<Log[]>;
    isFailed: boolean;
    error: ResponseError;
    requestParameters: string | undefined;
    searchCancelToken: CancelTokenSource;
    isCanceled: boolean;
    exactSearch: boolean;
    searchStarted: (requestParameters: string, cancelToken: CancelTokenSource) => void;
    searchFailed: (error: ResponseError) => void;
    searchSucceeded: (data: PagingResponseData<Log[]>) => void;
    searchCanceled: () => void;
    setExactSearch: (enabled: boolean) => void;
    reset: () => void;
}

export const initialState = {
    isSearching: false,
    searchResult: {} as PagingResponseData<Log[]>,
    isFailed: false,
    error: {} as ResponseError,
    requestParameters: '',
    searchCancelToken: {} as CancelTokenSource,
    isCanceled: false,
    exactSearch: false,
};

export const useLogsStore = create<LogsStore>(set => ({
    ...initialState,

    searchStarted: (requestParameters: string, cancelToken: CancelTokenSource) =>
        set({
            isSearching: true,
            isCanceled: false,
            requestParameters: requestParameters,
            searchCancelToken: cancelToken,
        }),

    searchFailed: (error: ResponseError) =>
        set({
            error: error,
            isSearching: false,
            isCanceled: false,
            isFailed: true,
            searchResult: {} as PagingResponseData<Log[]>,
        }),

    searchSucceeded: (data: PagingResponseData<Log[]>) =>
        set({
            searchResult: data,
            isCanceled: false,
            isSearching: false,
            isFailed: false,
        }),

    searchCanceled: () =>
        set({
            isCanceled: true,
        }),

    setExactSearch: (enabled: boolean) =>
        set({
            exactSearch: enabled,
        }),

    reset: () => set(initialState),
}));
